import { CustomerPortalAppearanceOptionsConverter, OrganizationDetailsVoData } from "../..";
var OrganizationConverter = /** @class */ (function () {
    function OrganizationConverter() {
    }
    OrganizationConverter.convertOrganizationDetailsToVo = function (organizationDetailsApiData) {
        var organizationDetailsVoData = new OrganizationDetailsVoData(organizationDetailsApiData.id);
        organizationDetailsVoData.uri = organizationDetailsApiData.uri;
        organizationDetailsVoData.name = organizationDetailsApiData.name;
        organizationDetailsVoData.customerPortalActivated = organizationDetailsApiData.customerPortalActivated;
        organizationDetailsVoData.canViewAnonymously = organizationDetailsApiData.canViewAnonymously;
        organizationDetailsVoData.canSubmitAnonymously = organizationDetailsApiData.canSubmitAnonymously;
        organizationDetailsVoData.visibilityPermissions = organizationDetailsApiData.visibilityPermissions; //FeedbackVisibilityPermissions
        organizationDetailsVoData.viewWorkItemsList = organizationDetailsApiData.viewWorkItemsList;
        organizationDetailsVoData.viewMyWorkItems = organizationDetailsApiData.viewMyWorkItems;
        organizationDetailsVoData.canSubmitFeedback = organizationDetailsApiData.canSubmitFeedback;
        organizationDetailsVoData.registrationPolicy = organizationDetailsApiData.registrationPolicy;
        organizationDetailsVoData.lifecycleStatusVisibleForLoggedIn = organizationDetailsApiData.lifecycleStatusVisibleForLoggedIn;
        organizationDetailsVoData.lifecycleStatusVisibleForEveryBody = organizationDetailsApiData.lifecycleStatusVisibleForEveryBody;
        organizationDetailsVoData.followingEnabled = organizationDetailsApiData.followingEnabled;
        organizationDetailsVoData.displayUserContainers = organizationDetailsApiData.displayUserContainers;
        organizationDetailsVoData.viewPreviouslySubmittedItems = organizationDetailsApiData.viewPreviouslySubmittedItems;
        organizationDetailsVoData.filterItemsByItemType = organizationDetailsApiData.filterItemsByItemType;
        organizationDetailsVoData.filterItemsByProject = organizationDetailsApiData.filterItemsByProject;
        organizationDetailsVoData.filterItemsByStatus = organizationDetailsApiData.filterItemsByStatus;
        organizationDetailsVoData.fileUrl = organizationDetailsApiData.fileUrl;
        organizationDetailsVoData.generatedCss = organizationDetailsApiData.generatedCss;
        organizationDetailsVoData.langKey = organizationDetailsApiData.langKey;
        organizationDetailsVoData.customLangFileId = organizationDetailsApiData.customLangFileId;
        organizationDetailsVoData.logo = organizationDetailsApiData.logo;
        organizationDetailsVoData.showFormBranding = organizationDetailsApiData.showFormBranding;
        organizationDetailsVoData.showPortalBranding = organizationDetailsApiData.showPortalBranding;
        organizationDetailsVoData.showCustomerApp = organizationDetailsApiData.showCustomerApp;
        organizationDetailsVoData.dateFormat = organizationDetailsApiData.dateFormat;
        organizationDetailsVoData.appearanceOptions = CustomerPortalAppearanceOptionsConverter.convertCustomerPortalAppearanceOptionsToVo(organizationDetailsApiData.appearanceOptions);
        return organizationDetailsVoData;
    };
    return OrganizationConverter;
}());
export { OrganizationConverter };
//# sourceMappingURL=organization-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/organization-converter.js
// module id = 971
// module chunks = 14